const { default: Axios } = require("axios");

export default class Ajax {
    /**
     *
     * @param {string} url
     * @param {callback} options.then
     * @param {callback} options.headers
     * @param {callback} options.always
     * @param {callback} options.fail
     */
    static get(url, options) {
        let opts = null;
        if (options.headers !== undefined) {
            opts.headers = options.headers;
        }

        Axios.get(url, opts)
            .then(response => {
                if (options.then !== undefined) {
                    options.then(response);
                }
            })
            .catch(e => {
                if (options.fail !== undefined) {
                    options.fail(e);
                } else {
                    console.log(e);
                }
            })
            .then(response => {
                if (options.always !== undefined) {
                    options.always(response);
                }
            });
    }

    /**
     *
     * @param {string} url
     * @param {any} data
     * @param {callback} options.headers
     * @param {callback} options.then
     * @param {callback} options.always
     * @param {callback} options.fail
     */
    static post(url, data, options) {
        let opts = null;
        if (options.headers !== undefined) {
            opts.headers = options.headers;
        }
        if (typeof data === 'string') {
            data += '&_method=POST';
        } else {
            if (data instanceof FormData) {
                data.append('_method', 'POST');
            } else {
                data._method = 'POST';
            }
        }
        Axios.post(url, data, opts)
            .then(response => {
                if (options.then !== undefined) {
                    options.then(response);
                }
            })
            .catch(e => {
                if (options.fail !== undefined) {
                    options.fail(e.response);
                } else {
                    console.error('no implementado');
                    console.log(e);
                }
            })
            .then(response => {
                if (options.always !== undefined) {
                    options.always(response);
                }
            });
    }

    /**
     *
     * @param {string} url
     * @param {any} data
     * @param {any} options.headers
     * @param {callback} options.then
     * @param {callback} options.always
     * @param {callback} options.fail
     */
    static put(url, data, options) {
        let opts = {};
        if (options.headers !== undefined) {
            opts.headers = options.headers;
        }
        if (typeof data === 'string') {
            data += '&_method=PUT';
        } else {
            if (data instanceof FormData) {
                data.append('_method', 'PUT');
            } else {
                data._method = 'PUT';
            }
        }
        Axios.post(url, data, opts)
            .then(response => {
                if (options.then !== undefined) {
                    options.then(response);
                }
            })
            .catch(e => {
                if (options.fail !== undefined) {
                    options.fail(e);
                } else {
                    console.error('no implementado');
                    console.log(e);
                }
            })
            .then(response => {
                if (options.always !== undefined) {
                    options.always(response);
                }
            });
    }

    /**
     *
     * @param {string} url
     * @param {any} data
     * @param {any} options.headers
     * @param {callback} options.then
     * @param {callback} options.always
     */
    static delete(url, data, options) {
        let opts = {};
        if (options.headers !== undefined) {
            opts.headers = options.headers;
        }
        if (typeof data === 'string') {
            data += '&_method=DELETE';
        } else {
            if (data instanceof FormData) {
                data.append('_method', 'DELETE');
            } else {
                data._method = 'DELETE';
            }
        }
        Axios.post(url, data, opts)
            .then(response => {
                if (options.then !== undefined) {
                    options.then(response);
                }
            })
            .catch(e => {
                if (options.fail !== undefined) {
                    options.fail(e);
                } else {
                    console.error('no implementado');
                    console.log(e);
                }
            })
            .then(response => {
                if (options.always !== undefined) {
                    options.always(response);
                }
            });
    }
}
